// Plan and upgrade copy: locked pages, the upgrade dialog, the Preferences
// "Unlock leadership tools" entry, AI usage and seat limits. Plan names are
// never written here (spec 7: they come from the server); `{plan}`,
// `{feature}` and friends are filled in by components/plan/upgradeText.ts.

export const plansCopy = {
  seePlans: 'See plans',
  notNow: 'Not now',
  ok: 'OK',
  askAdmin: 'Ask your account admin to upgrade.',
  currentPlan: "You're on the {plan} plan.",

  // A locked page reached by URL.
  locked: {
    withPlan: '{feature} comes with the {plan} plan.',
    withPlanPlural: '{feature} come with the {plan} plan.',
    noPlan: "{feature} isn't on your current plan.",
    noPlanPlural: "{feature} aren't on your current plan.",
  },

  // The dialog for a refused request.
  prompt: {
    title: "{feature} isn't on your plan",
    titlePlural: "{feature} aren't on your plan",
    titleGeneric: "This isn't on your plan",
    needsPlan: 'This needs the {plan} plan or above.',
    needsGeneric: 'Your current plan does not include this.',
    allowanceTitle: "This month's AI allowance is used up",
    transcriptsTitle: "This month's transcripts are used up",
    allowanceBody: 'AI requests are paused until the allowance resets.',
    allowanceResets: 'It resets on {date}. Everything else keeps working.',
  },

  // Preferences: one entry for plans missing any of the leadership tools. It
  // lists only what the plan lacks, in this order, under the plan that adds it.
  unlock: {
    navLabel: 'Unlock leadership tools',
    title: 'Unlock leadership tools',
    intro: 'The {plan} plan adds:',
    introNoPlan: 'Upgrading adds:',
    items: {
      strategicDrivers: 'Strategic drivers and KPIs, with how your time lines up against them',
      decisions: 'A decision log',
      delegation: 'Delegation tracking',
      peopleHistory: 'People history and interactions',
      principalProfile: 'Principal profiles',
      capacityPlanning: 'Capacity planning',
      projects: 'Projects',
      eaWorkspace: 'A free EA seat, so an assistant can run the day with you',
    },
    kept: 'Anything you added on a previous plan is kept and comes back when you upgrade.',
    // A tool the organisation's own plan includes, switched off for this one
    // organisation: upgrading wouldn't add it.
    switchedOff: "The {plan} plan includes these, but they aren't switched on for your organisation:",
    switchedOffNext: 'Contact support to have them switched on.',
  },

  // Preferences > AI & prompts.
  usage: {
    title: 'AI usage this month',
    used: '{used} of {allowance} AI operations used.',
    resets: 'The count resets on {date}.',
    over: 'You have gone past this month\'s allowance. AI keeps working up to {hardStop} operations, then pauses until the count resets.',
    whatCounts: 'An AI operation is anything you ask the AI to do: planning your day, replanning, capturing by voice, processing a transcript, turning an image into tasks, checking an idea against your priorities or generating a brief on demand. Quick Capture suggestions don\'t count.',
    briefs: 'Automatic meeting briefs today: {count} of {perDay}. These don\'t count as AI operations.',
  },

  // Admin: inviting people.
  seats: {
    justYou: 'Just you on this plan.',
    eaWithPlan: 'The EA seat comes with the {plan} plan.',
    eaNotIncluded: "The EA seat isn't on your current plan.",
    executivesFull: 'All {max} executive seats are in use.',
    easFull: 'All {max} EA seats are in use.',
    allFull: 'Every seat on your plan is in use.',
    addSeats: 'Add seats on the Billing page.',
  },
} as const;
